import { render, staticRenderFns } from "./studentsEditDataFamily.vue?vue&type=template&id=e3044b8a&scoped=true"
import script from "./studentsEditDataFamily.vue?vue&type=script&lang=js"
export * from "./studentsEditDataFamily.vue?vue&type=script&lang=js"
import style0 from "./studentsEditDataFamily.vue?vue&type=style&index=0&id=e3044b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3044b8a",
  null
  
)

export default component.exports